export const formatCount = (useSquareBrackets: boolean, count: number): string => {
    return useSquareBrackets ? `[${count}]` : `(${count})`;
};
